import { API_URL } from './config';

export async function createAgency(authToken, data) {
  if (!authToken) {
    return;
  }
  //console.log(JSON.stringify(data))
  const res = await fetch(`${API_URL}/agency`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-type': 'application/json' // "application/json" should be lowercase
    },
    body: JSON.stringify(data) // Convert data to JSON string
  });

  if (res.status === 400) {
    throw new Error('Failed to update the user. Try again!');
  }
  if (res.status === 401) {
    throw new Error('Email Id already exist!');
  }

  return await res.json();
}

export async function getAgencyDetails(authToken, userId) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/${userId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function getAgencyUniqueIdDetails(authToken, userId) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/uniqueId/${userId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function getAgencyByEmail(authToken, email) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/by/email/${email}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function updateDetails(authToken, id, data) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-type': 'application/json' // "application/json" should be lowercase
    },
    body: JSON.stringify(data) // Convert data to JSON string
  });

  if (res.status === 400) {
    throw new Error('Failed to update the user. Try again!');
  }

  return await res.json();
}

export async function updateAppDetails(authToken, org, location, data) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/${org}/${location}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-type': 'application/json' // "application/json" should be lowercase
    },
    body: JSON.stringify(data) // Convert data to JSON string
  });

  if (res.status === 400) {
    throw new Error('Failed to update the user. Try again!');
  }

  return await res.json();
}

export async function getAllAgencyList(authToken, location, org) {
  if (!authToken) {
    return;
  }

  const res = await fetch(
    `${API_URL}/agency/all/by/location/data/${location}/${org}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    }
  );
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function getCalenderDataAgency(authToken, id) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/agency/my/calender/data/${id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function getAgendaDataAgency(authToken, id, date) {
  if (!authToken) {
    return;
  }

  const res = await fetch(
    `${API_URL}/agency/my/calender/${date}/details/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    }
  );
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching user');
  }
  return await res.json();
}

export async function getAgencyJobList(authToken, id) {
  if (!authToken) {
    return;
  }

  const res = await fetch(
    `${API_URL}/agency/agency/all/job/full/list/data/${id}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json'
      }
    }
  );
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching template.');
  }
  return await res.json();
}
